import React, { useEffect } from 'react'
import { FaArrowUp } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import Typography from '../../../components/Basics/Typography'
import { onGetApplicationsAsync } from '../../../config/store/application.slice'
import * as Styled from './Footer.styles'

const formatCopyright = (application) => {
  if (!application?.app_copyright_year) {
    return null
  }

  return `© ${application.app_copyright_year} All Rights Reserved`
}

const Footer = () => {
  const { loading, application } = useSelector(state => state.applications)
  const dispatch = useDispatch()
  const copyrightText = formatCopyright(application)

  useEffect(() => {
    dispatch(onGetApplicationsAsync())
  }, [dispatch])

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Styled.FooterWrapper>
      <Styled.Container>
        <Styled.FooterBlock>
          {!loading && copyrightText && (
            <Typography variant='caption' display='inline'>
              {copyrightText}
            </Typography>
          )}
        </Styled.FooterBlock>

        <Styled.FooterBlock>
          <Typography variant='caption' display='inline'>
            Built with ♥ by Oscar Osses
          </Typography>
        </Styled.FooterBlock>

        <Styled.FooterBlock>
          <Styled.BackToTopButton
            type='button'
            onClick={handleBackToTop}
            aria-label='Back to top'
          >
            <FaArrowUp size='16' />
          </Styled.BackToTopButton>
        </Styled.FooterBlock>
      </Styled.Container>
    </Styled.FooterWrapper>
  )
}

export default Footer
